/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CatEventPaginationResponseDto,
  CatEventResponseDto,
  CreateCatEventPayloadDto,
  ErrorResponse,
  ReplaceCatEventPayloadDto,
} from '../models/index';
import {
    CatEventPaginationResponseDtoFromJSON,
    CatEventPaginationResponseDtoToJSON,
    CatEventResponseDtoFromJSON,
    CatEventResponseDtoToJSON,
    CreateCatEventPayloadDtoFromJSON,
    CreateCatEventPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ReplaceCatEventPayloadDtoFromJSON,
    ReplaceCatEventPayloadDtoToJSON,
} from '../models/index';

export interface CreateCatEventRequest {
    createCatEventPayloadDto: CreateCatEventPayloadDto;
}

export interface DeleteCatEventRequest {
    catEventId: string;
}

export interface FilterCatEventsRequest {
    searchText?: string;
    page?: number;
    pageSize?: number;
}

export interface GetCatEventByIdRequest {
    catEventId: string;
}

export interface ReplaceCatEventRequest {
    catEventId: string;
    replaceCatEventPayloadDto: ReplaceCatEventPayloadDto;
}

/**
 * 
 */
export class CatEventApi extends runtime.BaseAPI {

    /**
     * Create cat event
     */
    async createCatEventRaw(requestParameters: CreateCatEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatEventResponseDto>> {
        if (requestParameters['createCatEventPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createCatEventPayloadDto',
                'Required parameter "createCatEventPayloadDto" was null or undefined when calling createCatEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/cat-event`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCatEventPayloadDtoToJSON(requestParameters['createCatEventPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatEventResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create cat event
     */
    async createCatEvent(requestParameters: CreateCatEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatEventResponseDto> {
        const response = await this.createCatEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete cat event by id
     */
    async deleteCatEventRaw(requestParameters: DeleteCatEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['catEventId'] == null) {
            throw new runtime.RequiredError(
                'catEventId',
                'Required parameter "catEventId" was null or undefined when calling deleteCatEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/cat-event/{catEventId}`.replace(`{${"catEventId"}}`, encodeURIComponent(String(requestParameters['catEventId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete cat event by id
     */
    async deleteCatEvent(requestParameters: DeleteCatEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCatEventRaw(requestParameters, initOverrides);
    }

    /**
     * Filter cat events
     */
    async filterCatEventsRaw(requestParameters: FilterCatEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatEventPaginationResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/cat-event/filter`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatEventPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter cat events
     */
    async filterCatEvents(requestParameters: FilterCatEventsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatEventPaginationResponseDto> {
        const response = await this.filterCatEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get cat event by id
     */
    async getCatEventByIdRaw(requestParameters: GetCatEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatEventResponseDto>> {
        if (requestParameters['catEventId'] == null) {
            throw new runtime.RequiredError(
                'catEventId',
                'Required parameter "catEventId" was null or undefined when calling getCatEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/cat-event/{catEventId}`.replace(`{${"catEventId"}}`, encodeURIComponent(String(requestParameters['catEventId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatEventResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get cat event by id
     */
    async getCatEventById(requestParameters: GetCatEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatEventResponseDto> {
        const response = await this.getCatEventByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace cat event
     */
    async replaceCatEventRaw(requestParameters: ReplaceCatEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatEventResponseDto>> {
        if (requestParameters['catEventId'] == null) {
            throw new runtime.RequiredError(
                'catEventId',
                'Required parameter "catEventId" was null or undefined when calling replaceCatEvent().'
            );
        }

        if (requestParameters['replaceCatEventPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'replaceCatEventPayloadDto',
                'Required parameter "replaceCatEventPayloadDto" was null or undefined when calling replaceCatEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/cat-event/{catEventId}/replace`.replace(`{${"catEventId"}}`, encodeURIComponent(String(requestParameters['catEventId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceCatEventPayloadDtoToJSON(requestParameters['replaceCatEventPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatEventResponseDtoFromJSON(jsonValue));
    }

    /**
     * Replace cat event
     */
    async replaceCatEvent(requestParameters: ReplaceCatEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatEventResponseDto> {
        const response = await this.replaceCatEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
